import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useGetTeacheIdByUserId } from "../../../hooks/useGetTeacheIdByUserId";
import { useGetUserByIdQuery } from "../../../hooks/useGetUsersQuery";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";
import { PaymentTransactionType, PayStudentDebtType, StudentDebtType } from "../../../types/Finance";
import { CreateStudentDebtFormValidation } from "./CreateStudentDebtFormValidation";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFieldArray, useForm } from "react-hook-form";
import { PayStudentDebtTypeFormValidation } from "./PayStudentDebtTypeFormValidation";
import { createStudentDebt, updateStudentDebt } from "../../../services/finance/studentDebt";
import { useMutation } from "react-query";
import { routes } from "../../../routes";
import toast from "react-hot-toast";
import { ChevronLeftIcon, EnterIcon, PlusIcon } from "@radix-ui/react-icons";
import { Card, Flex, Button, Spinner, Box,Text } from "@radix-ui/themes";
import DateFieldComponent from "../../../components/inputs/Datefield/DatefieldComponent";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import TextAreaFieldComponent from "../../../components/inputs/TextAreafield/TextAreafieldComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { resetStudentData } from "../../../redux/slices/school/student";
import { resetUserData } from "../../../redux/slices/users/user";
import { resetStudentDebtData } from "../../../redux/slices/finance/studentDebt";
import { PaymentTransactionsForm } from "./PaymentTransactionsForm";
import { useState } from "react";
import { createPaymentTransaction, updatePaymentTransaction } from "../../../services/finance/paymentTransaction";
import { dataURLtoFile, getFile, getFileExt } from "../../../utils/fileUtils";
import { resetPreviousPath } from "../../../redux/slices/previousPath";
import { useGetPaymentMethodsQuery } from "../../../hooks/useGetPaymentMethodsQuery";

export const StudentDebtPaymentTransactions = () => {
    const studentDebt = useSelector((state: RootState) => state.studentDebt);
    const mutationSave = useMutation({ mutationFn: createPaymentTransaction, mutationKey: 'createPaymentTransaction' });
    const mutationEdit = useMutation({ mutationFn: updatePaymentTransaction, mutationKey: 'updatePaymentTransaction' });
    const mutationEditStudentDebt = useMutation({ mutationFn: updateStudentDebt, mutationKey: 'updateStudentDebt' });
    const loadingState = mutationSave.isLoading || mutationEdit.isLoading || mutationEditStudentDebt.isLoading ;
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [errorTransactions, setErrorTransactions] = useState<string | null>(null);
    const previousPath = useSelector((state: RootState) => state.previousPath);

    const { data:paymentTypesData} = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 4000 });
    const { data:paymentMethodsData} = useGetPaymentMethodsQuery({ PageNumber: 1, PageSize: 4000 });

    const paymentTransactions = 
    studentDebt.paymentTransation && studentDebt.paymentTransation.length>0?
     studentDebt.paymentTransation.map(paymentTransation=> {
      if (paymentTransation.paymentProof) {
        const file = dataURLtoFile(paymentTransation.paymentProof, getFileExt(paymentTransation.paymentProof,"esura-proof.pdf"));
        return { ...paymentTransation, file,};
      }
      return {...paymentTransation}
     })
    :
    [{
      idStudent: studentDebt.idStudent,
      idPaymentType: studentDebt.idPaymentType,
      date: "",
      idStudentDebt: studentDebt.id,
      amountPaid: 0,
      paymentProof: "",
      idCompleted: true
    }]
    const defaultValues:PayStudentDebtType={
        studentDebt: studentDebt,
        paymentTransation: paymentTransactions as PaymentTransactionType[]
    }
    const { control, handleSubmit, formState: { errors },setValue,getValues ,watch} = useForm<PayStudentDebtType>
    (
      {
        resolver: yupResolver(PayStudentDebtTypeFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
        disabled:true
      }
    );
    const { fields, append, remove,  } = useFieldArray({
      control, 
      name: 'paymentTransation',
    });
    const  valid= (paymentTransactios: PaymentTransactionType[]) => {
      const total =  paymentTransactios.reduce((total, paymentTransaction) => Number(total) + (Number(paymentTransaction.amountPaid) || 0), 0)
     const isSumLess =  total > studentDebt.currentAmount;
     return isSumLess;
    }
    const onSubmit = handleSubmit(async (data) => {
        try {
          //const  isInvalidPaymentTransactios = valid(data.paymentTransation);
          // if(isInvalidPaymentTransactios)
          // {
          //   setErrorTransactions("A soma dos pagamentos não pode ser maior que o valor actual")
          //   return;
          // }
          // setErrorTransactions(null)
          const forEdit = data.paymentTransation.filter(pt=> pt.id);
          const forSave = data.paymentTransation.filter(pt=> !pt.id);
          await Promise.all(forSave!.map(async (cv) => {
            if(cv.file){
              const { base64} =  await getFile(cv.file)
              cv.paymentProof = base64;
            }
            cv.idStudentDebt = studentDebt.id;
            return mutationSave.mutateAsync(cv)
          }))

         await Promise.all(forEdit!.map(async (cv) => {
          if(cv.file){
            const { base64} =  await getFile(cv.file)
            cv.paymentProof = base64;
          }
            return mutationEdit.mutateAsync(cv)
          }))
          const total =  data.paymentTransation.reduce((total, paymentTransation) => Number(total) + (Number(paymentTransation.amountPaid) || 0), 0)
          let _studentDebtToSend:StudentDebtType  ={...studentDebt} 
          if (total >= studentDebt.currentAmount) {
            _studentDebtToSend = {
              ..._studentDebtToSend,
              currentAmount: 0,
              isPayed: true,
              paidDate: new Date().toISOString(),
            }
          }
          if (total < studentDebt.currentAmount) {
            _studentDebtToSend = {
              ..._studentDebtToSend,
              currentAmount: Math.abs(total - studentDebt.currentAmount)
            }
          }
          await mutationEditStudentDebt.mutateAsync(_studentDebtToSend)
          toast.success("Cobrança paga!");
          handleBack();
        } catch (err: any) {
          toast.error(`${mutationSave.error ?? mutationSave.error ?? err?.message}`);
        }
      });
      const handleBack = () => {
        dispatch(resetStudentDebtData());
        const path = previousPath?.previousPath;
        if(path){
          navigate(path)
          dispatch(resetPreviousPath())
          return;
        }

        navigate(routes.studentDebts);
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    return (
        <form onSubmit={onSubmit} noValidate>
          <Card size='1'>
            <Flex direction='column' gap='4'>
{/*             
              {userData && userData.id && <>
                <UserPreview/>
              </>} */}
               <SelectComponent name="studentDebt.idPaymentType" label="Tipo de pagamento" control={control} errors={errors} style={{ width: '100%' }}
                options={paymentTypesData?.items.map((paymentType) => ({
                  value:  paymentType?.id?? "",
                  label: paymentType?.description ?? ""
                }))}
                fieldProps={{ disabled:true }}
              />
              <TextFieldComponent name="studentDebt.originalAmount" label="Valor a pagar" control={control} errors={errors} fieldProps={{ placeholder: 'Valor a pagar', disabled:true }} />
              <TextFieldComponent name="studentDebt.currentAmount" label="Valor a pagar remanescente" control={control} errors={errors} fieldProps={{ placeholder: 'Valor a pagar remanescente', disabled:true }} />
              <DateFieldComponent name="studentDebt.dueDate" label="Data de vencimento" control={control} errors={errors} style={{ width: '100%' }}  fieldProps={{ disabled:true }}/>
              <TextAreaFieldComponent
                    name="studentDebt.description"
                    label="Descrição"
                    control={control}
                    errors={errors}
                    fieldProps={{ placeholder: 'Descrição',disabled:true }}
                    style={{ width: '100%' }}
                  />
            <Box>
            </Box>
            {fields.map((field, index) => (
              <PaymentTransactionsForm
                key={field.id}
                index={index}
                field={field}
                control={control}
                errors={errors}
                watch={watch}
                remove={() => {}}
                viewMode={true}
                paymentMethods={paymentMethodsData?.items??[]}
              />
            ))}
                      {errorTransactions && (
              <Text color="red" size="2">
                {`${errorTransactions}`}
              </Text>
            )}
              <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                <Button color='red' onClick={handleBack} disabled={loadingState}>
                  <ChevronLeftIcon /> voltar
                </Button>
              </Flex>
            </Flex>
          </Card>
        </form>
      );
}

